import image1 from './Banners-Electricity.png';
import image2 from './Banners-Emissions.png';
import image3 from './Banners-Waste.png';
import image4 from './Banners-Water.png';

export default [
  image1, image2, image3, image4, image2, image3
];